import { put, takeLatest } from 'redux-saga/effects';
import { SetSerialNumberOld } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { pk, IDLicenza, new_sn_old, codiceUtente } }) {
    try {

        const token = yield authService.getAccessToken();
        
        const response = yield fetch('/Licenses/SetSerialNumberOld/'
            + pk + '/'
            + IDLicenza + '/'
            + (new_sn_old === '' ? -1 : new_sn_old )+ '/'
            + codiceUtente, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            });

        let isInserted = '';

        isInserted = yield response.text();

        if (isInserted === "inserted")
            yield put(SetSerialNumberOld.creators.setSerialNumberOldSuccess({ isInserted }));
        else yield put(SetSerialNumberOld.creators.setSerialNumberOldFailed(isInserted));

    } catch (e) {
        yield put(SetSerialNumberOld.creators.setSerialNumberOldFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(SetSerialNumberOld.types.SET_SN_OLD_REQUEST, runAction);
}